var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.33,
    height: 29.33,
    viewBox: "0 0 29.33 29.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-6000.03 -6401.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M6028.641,6413.7l-3.2-.147a.753.753,0,0,1-.661-.465l-.66-1.586a.753.753,0,0,1,.141-.8l2.158-2.368a.756.756,0,0,0-.024-1.041l-2.66-2.661a.758.758,0,0,0-1.043-.024l-2.366,2.158a.757.757,0,0,1-.8.14l-1.587-.658a.753.753,0,0,1-.463-.663l-.148-3.2a.755.755,0,0,0-.753-.72h-3.764a.756.756,0,0,0-.754.72l-.147,3.2a.753.753,0,0,1-.464.663l-1.586.658a.755.755,0,0,1-.8-.14l-2.368-2.158a.756.756,0,0,0-1.042.024l-2.659,2.661a.752.752,0,0,0-.024,1.041l2.157,2.368a.752.752,0,0,1,.139.8l-.657,1.586a.753.753,0,0,1-.663.465l-3.2.147a.756.756,0,0,0-.72.753v3.764a.755.755,0,0,0,.72.753l3.2.148a.751.751,0,0,1,.663.464l.657,1.587a.752.752,0,0,1-.139.8l-2.157,2.366a.754.754,0,0,0,.023,1.043l2.662,2.66a.754.754,0,0,0,1.041.025l2.367-2.159a.756.756,0,0,1,.8-.139l1.586.657a.755.755,0,0,1,.464.663l.147,3.2a.755.755,0,0,0,.754.719h3.764a.753.753,0,0,0,.752-.719l.149-3.2a.754.754,0,0,1,.463-.663l1.587-.657a.756.756,0,0,1,.8.139l2.367,2.159a.757.757,0,0,0,1.043-.025l2.66-2.66a.758.758,0,0,0,.024-1.043l-2.158-2.366a.752.752,0,0,1-.141-.8l.659-1.587a.752.752,0,0,1,.662-.464l3.2-.148a.753.753,0,0,0,.719-.753v-3.764A.754.754,0,0,0,6028.641,6413.7Zm-13.945,7.425a4.79,4.79,0,1,1,4.789-4.789A4.791,4.791,0,0,1,6014.7,6421.122Z",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/iconSetting.c3a856c18724ce5a1ca3b326ca730da6.svg";
export { ForwardRef as ReactComponent };